module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-index"
  }, [_c('div', [_c('div', {
    staticClass: "list-block media-list"
  }, [_c('ul', _vm._l((_vm.merchListWithoutCustomized10), function(pro) {
    return _c('li', [_c('a', {
      staticClass: "item-link item-content",
      on: {
        "click": function($event) {
          return _vm.clickMerchandise(pro)
        }
      }
    }, [_c('div', {
      staticClass: "item-inner",
      staticStyle: {
        "padding-bottom": "0rem"
      }
    }, [(_vm.filteredShowPromotions(pro) && _vm.filteredShowPromotions(pro).length > 0) ? _c('div', {
      staticClass: "item-title-row"
    }, [_c('span', [_c('span', {
      staticStyle: {
        "font-size": "0.5rem",
        "color": "red",
        "padding": "0.1rem"
      }
    }, [_vm._v(_vm._s(_vm.filteredShowPromotions(pro)[0].name))])]), _vm._v(" "), (_vm.filteredShowPromotions(pro)[0].type === 6) ? _c('div', {
      staticClass: "item-after"
    }, [(_vm.secFlag !== 2) ? _c('img', {
      attrs: {
        "src": "/emktResources/resocurces/img/promotion/miaosha_mobile.png",
        "alt": "秒杀进行/预告",
        "height": "30px"
      }
    }) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-title"
    }, _vm._l((pro._titleList), function(title) {
      return _c('span', {
        staticStyle: {
          "margin-right": ".3rem"
        }
      }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "item-subtitle",
      staticStyle: {
        "font-size": "xx-small"
      }
    }, [_vm._l((pro._abstractList), function(abstract) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [_c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [(abstract.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstract.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstract.valueText))])])])])
    }), _vm._v(" "), _vm._l((pro._subTitleList), function(subTitle) {
      return _c('label', {
        staticClass: "label-checkbox checkbox-el "
      }, [_c('div', {
        staticClass: "item-media small-checkbox small-filter-el"
      }, [_c('div', {
        staticClass: "span-text radiuscolor",
        staticStyle: {
          "font-size": "xx-small",
          "margin-right": ".3rem"
        }
      }, [_vm._v(_vm._s(subTitle.valueText))])])])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_c('div', {
      staticStyle: {
        "height": "1.6rem"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.priceMax))]) : _c('span', {
      staticStyle: {
        "color": "#1D66E1",
        "font-size": ".7rem"
      }
    }, [_vm._v("¥" + _vm._s(pro.priceMin))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": ".3rem"
      }
    }, [_c('button', {
      staticClass: "button workdays"
    }, [_vm._v("周期" + _vm._s(pro.cycle) + "工作日")])])]), _vm._v(" "), _vm._m(0, true)])]), _vm._v(" "), (pro._attributes.Product_Master && pro._attributes.Product_Master.value !== 'Customize') ? _c('div', {
      staticStyle: {
        "font-size": ".4rem",
        "margin-bottom": ".5rem",
        "color": "rgb(29, 102, 225)"
      }
    }, [_vm._v(_vm._s(pro._attributes.Product_Master.value))]) : _vm._e()])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "font-size": ".5rem"
    }
  }, [_c('span', {
    staticClass: "sub-span"
  }, [_vm._v("现货")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bf0ad2a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finder/components/NewMerchandiseListB.vue
// module id = 1651
// module chunks = 8